import { Tier } from '@mc/api'
import { track, EventTypes } from '@mc/track-event'

export const trackCheckoutClick = (tier?: Tier) =>
  track(EventTypes.CHECKOUT_CLICK, {
    category: 'product_selection',
    action: tier?.internalName,
  })
